var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarE = function SvgDefaultAvatarE(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_e_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_e_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 45.2c1.2 0 1.7-2.6 1.7-5.3 0-2.7-.5-5.3-1.7-5.3-.9 0-1.1 1-1.1 3.2-.5.8-4.4.8-7.9.8H36V33c0-3 .2-4.7 1-4.9h3.8c3.7 0 6.4.3 7 1 .3.4.7 1.3 1.1 2.7.4 1.4.8 2.3 1.6 2.3s1.3-.9 1.3-2.5c0-2.9-1.4-7-3.1-7-1.2 0-1 .7-2.7.7H32.7c-3.7 0-5.6.3-5.6 1.5 0 .9 1 1.2 3.2 1.3.5.2.7 2.1.7 4.5v15.2c0 2.3-.2 4.3-.7 4.5-2.2.1-3.2.4-3.2 1.4 0 1.2 2 1.5 5.6 1.5h13.9c1.8 0 1.5.7 2.7.7 1.8 0 3.5-4.7 3.5-7.8 0-1.5-.5-2.4-1.3-2.4-.9 0-1.4 1-1.8 2.6-.5 1.7-.8 2.6-1.3 3-.7.6-3.3 1.1-7.6 1.1h-3.9c-.8-.1-1-1.9-1-4.9v-6h.3c3.5 0 7.4 0 7.9.8.1 2 .3 2.9 1.2 2.9z"
  })));
};
export default SvgDefaultAvatarE;